import { Link, NavLink } from "react-router-dom";
import LogoMark from "./LogoMark";

export default function Header() {
  return (
    <header className="masthead">
      <div className="wrap">
        <Link className="wordmark" to="/">
          <LogoMark className="bulb" />
          Gapsmiths
        </Link>
        <nav aria-label="Main">
          <NavLink to="/what-we-do">What we do</NavLink>
          <NavLink to="/our-ip">Our IP &amp; products</NavLink>
          <NavLink to="/contact">Contact</NavLink>
        </nav>
      </div>
    </header>
  );
}
